import React ,{useMemo}from "react";
import ReadersType from "./ComponentsTpes/ReadersTypes";

const FINGER = ({ selectedPorts, componentSourceOptions,  ACUModel,
    setSelectedPorts, savedData, setSavedData, selectedType }) => {

        const selectOptions = (key, value) => {
            setSavedData(prevData => {
                return {
                    ...prevData,
                    FINGER:{
                        ...prevData[`FINGER`],
                        [key]: value
                    }
                }
            })
        }

        const data=useMemo(()=>{
            return savedData[`FINGER`]
        },[savedData])

  return (<ReadersType
        ACUModel={ ACUModel}
        source={componentSourceOptions.readersData}
        component_source={data.component_source?.value }
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        selectOptions={selectOptions}
        name={data.name}
        port={data.port}
        mode={data.mode}
        readerType={data.readerType}
        wiegandType={ data.wiegandType}
        enable_crc={data.enable_crc}
        reverse_byte_order={data.reverse_byte_order}
        direction={data.direction}
        enable_buzzer={data.enable_buzzer} />)
}

export default FINGER;